module.exports = __webpack_public_path__ + "static/media/drop.e9fd31f3.png";